import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createCsvMockEndpoint } from '@/mocks/create-csv-mock-endpoint';
import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { CampaignShopDownloadResponse } from '@/repositories/generated';

const response: CampaignShopDownloadResponse = {
  presignedUrl: createCsvMockEndpoint([
    ['店舗ID', '店舗名'],
    ['00000001', '店舗1'],
  ]),
};

export const campaignShopDownload = http.get(
  createMockEndpoint('/campaign/:id/download/shop'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
